// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"257":"dda9c488","348":"5cb9ef14","397":"19c56820","449":"d111bb61","453":"d855a71b","637":"9ebedffd","755":"9782ddef","801":"2a6e4024","835":"5e96b40e"}[chunkId] + ".chunk.js";
};